import $ from 'jquery'
import 'floatthead'

const floatThead = {}
let table = undefined

floatThead.install = (Vue) => {
    Vue.directive('float-thead', {
        inserted(el){
            //console.log(el)
                        
            if(el.className == 'table-responsive'){
                table = $(el.childNodes[0])
            }
            else{
                table = $(el)            
                //console.log(table)     
            }            
            
            table.floatThead({
                position: "fixed",                
            })
            
            setTimeout(() => {
                table.floatThead()
                table.trigger('reflow');                
            }, 5000); 
        }
    })
}

export default floatThead